import type {User} from "./types";

export const parseUser: User = (datum, language) => {
    if (!datum) return;
    return {
        id: datum.get('id'),
        loginName: datum.getIn(['loginName', language]),
        username: datum.get('username'),
        locale: datum.get('locale'),
    }
}